import App from 'App';
import { Spinner } from 'components/Spinner';
import { Loadable, Loading, LoadingState } from 'LoadingState';
import Query from 'query/Query';
import Schema from 'query/Schema';
import { LoadableQuery } from 'query/SkeletalQuery';

import React from 'react';


export interface QueryListProps {
    transientSchemas?: Loadable<Schema[]>;
    usersSchemas?: Loadable<Schema[]>;
    onSelect: (x: LoadableQuery) => void;
}

export interface QueryListState {
    selected?: Query;
}

export class QueryList extends React.Component<QueryListProps, QueryListState> {
    private app: App;

    constructor(props: QueryListProps, app: App) {
        super(props);
        this.state = {}
        this.app = app;
    }

    // TODO: context menus for deleting stuff, renaming stuff.
    render = () => {
        return <>
            {this.renderSchemas(this.props.transientSchemas)}
            {/*this.renderSchemas(this.props.usersSchemas)*/}
        </>
    }

    private renderSchemas(schemas: Loadable<Schema[]> | undefined) {
        if (schemas) {
            switch (schemas.getState()) {
                case LoadingState.Loading:
                    return <>
                        <Spinner />;
                    </>
                case LoadingState.Loaded:
                    let sch = schemas.getValue();
                    return <>
                        <ul className='queryList'>
                            {
                                sch.map(each => {
                                    return <div key={each.name}>
                                        <h3 className='queryList-heading'>{each.name}</h3>
                                        {each.querys.map(each2 => {
                                            return <li className={this.state.selected === each2 ? 'queryList-item-selected' : 'queryList-item'}
                                                key={each2.getKey()}
                                                onClick={() => this.props.onSelect(each2)}>{each2.getName()}</li>;
                                        })}
                                    </div>
                                })
                            }
                        </ul>
                    </>

                case LoadingState.Error:
                    // TODO: fancy error component.
                    return <span>{schemas.getError().message}</span>;
            }
        }
    }
}